import React, { useCallback, useEffect, useState } from 'react';

import { Col, Flex, Loading, Page, Row, SearchBar, Section, Section2, Typography } from 'components';
import { useSchool } from 'features/school';

import { ExamsCard, ExamsListResponse, ExamsViews, useExams } from 'features/exams';
import { request } from 'app/utils';
import { factoryCardSearch } from 'features/exams/components/examsCard';

import usestorage from 'app/utils/storage';
import { useSearchParams } from 'react-router-dom';

const ExamsList = () => {
  const [loadingEdit, setLoadingEdit] = useState(true);
  const [view] = useState<ExamsViews>('grid');

  const { apiGatewayUrl } = useSchool();
  const { exams, setExams, clearExams, currentPage, totalPages } = useExams();

  const [searchText, setSearchText] = useState('');
  const [order] = useState<number>(0);
  const [page, setPage] = useState<number>(1);
  const [size, setSize] = useState<number>(20);

  const storage = usestorage('localStorage');
  const currentDashboard = storage.get('currentDashboard');

  const [searchParams] = useSearchParams();
  const currentDashboardArea = searchParams.get('dashboardAreaUuid');

  const fetchExams = useCallback(async () => {
    setLoadingEdit(true);

    await Promise.all([
      request<ExamsListResponse>({
        url: '/api/v1/School/PracticeExam/Search',
        method: 'get',
        baseURL: apiGatewayUrl,
        params: {
          searchFor: searchText,
          searchOrder: order,
          page,
          size,

          ...(currentDashboard ? { dashboardUuid: currentDashboard } : {}),
          ...(currentDashboardArea ? { dashboardAreaUuid: currentDashboardArea } : {}),
        },
      }).then(({ data }) => {
        setExams(data);
      }),
    ]).then(() => {
      setLoadingEdit(false);
    });
  }, [searchText, order, page, size, currentDashboard, currentDashboardArea]);

  useEffect(() => {
    fetchExams();
  }, [searchText, order, page, size, currentDashboard, currentDashboardArea]);

  useEffect(() => {
    return () => {
      clearExams();
    };
  }, []);

  return (
    <Page title="Avaliações">
      {loadingEdit && <Loading alpha={0.8} />}

      <Flex bg="white" flexDirection="column">
        <Flex flexGrow={0} bg="gray_200">
          <Flex flexDirection="column" py={{ m: 4, d: 8 }}>
            <Section2>
              <Typography type="type8" fontWeight="bold">
                Todas as avaliações
              </Typography>
            </Section2>
          </Flex>
        </Flex>

        <Flex bg="white" flexGrow={0} flexDirection="column">
          <Section py={{ m: 30, t: 60 }} flexDirection="column">
            <SearchBar
              searchText={searchText}
              searchPlaceholder="Buscar avaliação"
              onSearchTextChange={(value) => {
                setPage(1);
                setSearchText(value);
              }}
              setPage={setPage}
              totalPages={totalPages}
              currentPage={currentPage}
              selectedRows={false}
              filters={[
                {
                  selectedValue: size,
                  onChange: (changedSize) => {
                    setPage(1);
                    setSize(Number(changedSize));
                  },
                  options: [
                    { value: 20, label: '20' },
                    { value: 50, label: '50' },
                    { value: 100, label: '100' },
                  ],
                  minWidth: 150,
                },
              ]}
              // setPage={setPage}
              // actions={[
              //   {
              //     icon: 'gridView',
              //     onClick: () => setView('grid'),
              //     label: 'Visualizar em grid',
              //     active: view === 'grid',
              //   },
              //   {
              //     icon: 'sequentialView',
              //     onClick: () => setView('list'),
              //     label: 'Visualizar em lista',
              //     active: view === 'list',
              //   },
              // ]}
            />

            {exams.length ? (
              <Row gutter={20}>
                {exams.map((exam, index) => (
                  <Col key={`exam-item-${index.toString()}`} width={view === 'grid' ? { m: 1, t: 1 / 2, d: 1 / 4 } : 1} mt={20}>
                    <ExamsCard view={view} {...factoryCardSearch(exam)} />
                  </Col>
                ))}
              </Row>
            ) : (
              <Typography mt={5} fontWeight="bold">
                {loadingEdit ? <>Por favor, aguarde.</> : <>Nenhuma avaliação encontrada{!!searchText ? ` com o termo "${searchText}"` : ''}.</>}
              </Typography>
            )}
          </Section>
        </Flex>
      </Flex>
    </Page>
  );
};

export default ExamsList;
